import { useEffect, useRef, useCallback } from 'react'
import { Text } from '@pixi/react'
import { Text as PixiText, TextStyle } from 'pixi.js'
import gsap from 'gsap'
import { TextProps } from '../type/PixiType'

const defaultTextStyle = new TextStyle({
  fill: '#FFEFD5',
  fontFamily: 'Arial, sans-serif',
  fontSize: 40,
  fontWeight: '700',
})

type BreathingTextProps = {
  alphaStart?: number
  alphaEnd?: number
  durationSeconds?: number
} & TextProps

export const BreathingText = ({
  alphaStart = 0.04,
  alphaEnd = 1,
  durationSeconds = 1.3,
  anchor = 0.5,
  style = defaultTextStyle,
  ...textProps
}: BreathingTextProps) => {
  const textRef = useRef<PixiText | null>(null)

  useEffect(() => {
    if (!textRef.current) return

    const tl = gsap.timeline({ repeat: -1, yoyo: true })

    tl.fromTo(
      textRef.current,
      { alpha: alphaStart },
      {
        alpha: alphaEnd,
        duration: durationSeconds,
        ease: 'power1.inOut',
      },
    )
    return () => {
      tl.kill()
    }
  }, [alphaStart, alphaEnd, durationSeconds])

  const setRef = useCallback((el: PixiText | null) => {
    textRef.current = el
  }, [])

  return (
    <Text
      name="breathing text"
      ref={setRef}
      anchor={anchor}
      style={style}
      {...textProps}
    />
  )
}
